<template>
    <transition name="fade">
    <div class="message" v-show="open">
        <slot></slot>
    </div>
    </transition>
</template>
<style  scoped>
    .message {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 50px;
        background-color: rgb(30, 155, 30);
        z-index: 2000;
        font-size: 17px;
        color: white;
        text-align: center;
        vertical-align: middle;
        padding-top: 10px;
    }
   .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    }
</style>
<script>
export default {
    data() {
        return {
            open: false
        }
    },
    methods: {
        showMsg() {
            this.open = true;
            setTimeout(()=> {
                this.open = false;
            }, 1500)
        }
    }
}
</script>